








































import { Component, Vue } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";

@Component({ name: "Forbidden" })
export default class Forbidden extends Vue {
  userModule = userModule;

  get formCode(): string {
    return (this.$route.query.form as string) || "";
  }

  get action(): string {
    return (this.$route.query.action as string) || "";
  }

  goHome(): void {
    this.$router.push("/dashboard-poliklinik").catch(() => {
      /* ignore navigation duplicate */
    });
  }
}
